import api from './api'

/** Endpoint agregado de redes remotas de todos os peers (para seção "Rotas para:"). */
export const routingApi = {
  getPeersRemoteNetworks: async (vpnNetworkId, excludePeerId) => {
    const params = excludePeerId ? { excludePeerId } : {}
    const response = await api.get(`/vpn/networks/${vpnNetworkId}/peers-remote-networks`, { params })
    return response.data
  },
}
